import { types } from "../types/types";

const initialState = {
  searchInfo: {}
};
export const searchInfoReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case types.SEARCH_INFO_START_REGISTER:
      return {
        ...state,
        searchInfo: action.payload
      };

    default:
      return state;
  }
};